import TableComponent from "../../components/TableComponent";

const CategoryList = ({
  columns,
  rows,
  count,
  loading,
  page,
  onPageChange,
}: {
  columns: any;
  rows: any;
  count: number;
  page: number;
  loading: boolean;
  onPageChange: (_: any, page: number) => void;
}) => {
  return (
    <>
      <div className="sorting_table">
        <TableComponent
          count={count}
          onPageChange={onPageChange}
          loading={loading}
          page={page}
          columns={columns || []}
          rows={rows}
        />
      </div>
    </>
  );
};

export default CategoryList;
